/**
 * 経路情報の actions
 */
const actions = {
  /**
   * 検索条件を変更します
   */
  condition: ({ commit }, payload) => {
    commit('condition', payload);
  },
  /**
   * 経路情報を変更します
   */
  routes: ({ commit }, payload) => {
    commit('routes', payload);
  },
  /**
   * 経路情報を変更します
   */
  route: ({ commit }, payload) => {
    commit('route', payload);
  },
  /**
   * 経路種別を変更します
   */
  routeType: ({ commit }, payload) => {
    commit('routeType', payload);
  },
  /**
   * ルートサマリ表示判定を変更します
   */
  visibleSummary: ({ commit }, payload) => {
    commit('visibleSummary', payload);
  },
  /**
   * ルート詳細表示判定を変更します
   */
  visibleDetail: ({ commit }, payload) => {
    commit('visibleDetail', payload);
  },
};

export { actions as default };
